export default "__VITE_ASSET__BMX7VZLZ__"